import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationWithPlan } from '../../../../types';

type CellParams = ICellRendererParams<LocationWithPlan> & { branchId: () => number };

@Component({
  selector: 'app-pan-cell-billing-portal-cell-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './billing-portal-cell-actions.component.html',
  styleUrl: './billing-portal-cell-actions.component.scss',
})
export class CellBillingPortalCellActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
